import { SUPERVISOR_TAB_FOOTAGE_STATUS } from '@/features/supervisor/config/activity';
import { resolveSupervisorDateRange } from '@/features/supervisor/lib/dateRange';
import { normalizeSupervisorSearch } from '@/features/supervisor/lib/search';
import type {
  SupervisorActivitySearch,
  SupervisorActivitySessionFilters,
  SupervisorCamerasFilters,
  SupervisorCamerasSearch,
  SupervisorOrganizationSearch,
  SupervisorOverviewSearch,
  SupervisorTeamScope,
} from '@/features/supervisor/types/supervisor';
import { browserTimeZone } from '@/shared/lib/dateTime';

function resolveOrganizationIds(
  search: SupervisorOrganizationSearch,
): readonly string[] | undefined {
  return search.organizationId?.length ? [...new Set(search.organizationId)].sort() : undefined;
}

export function toSupervisorTeamScope(search: SupervisorOverviewSearch): SupervisorTeamScope {
  const timeZone = browserTimeZone();
  const organizationId = resolveOrganizationIds(search);
  return {
    organizationId,
    projectId: organizationId?.length === 1 && search.projectId ? [search.projectId] : undefined,
    ...resolveSupervisorDateRange(search),
    timeZone,
  };
}

export function toSupervisorActivitySessionFilters(
  search: SupervisorActivitySearch,
): SupervisorActivitySessionFilters {
  const tab = search.tab ?? 'all';
  return {
    ...toSupervisorTeamScope(search),
    runner: search.runner,
    opsCode: search.opsCode,
    environmentId: search.environmentId,
    operatorId: search.operatorId,
    operatorPresence: search.operatorPresence,
    q: normalizeSupervisorSearch(search.q),
    recording: tab === 'all' ? search.recording : undefined,
    footageStatus: tab === 'all' ? search.footageStatus : [SUPERVISOR_TAB_FOOTAGE_STATUS[tab]],
  };
}

export function toSupervisorCamerasFilters(
  search: SupervisorCamerasSearch,
): SupervisorCamerasFilters {
  const timeZone = browserTimeZone();
  return {
    organizationId: resolveOrganizationIds(search),
    status: search.status,
    q: normalizeSupervisorSearch(search.q),
    ...resolveSupervisorDateRange(search),
    timeZone,
  };
}

export function toSupervisorTeamSearch(search: SupervisorOverviewSearch): SupervisorOverviewSearch {
  return {
    organizationId: search.organizationId,
    projectId: search.projectId,
    dateFrom: search.dateFrom,
    dateTo: search.dateTo,
  };
}

export function toSupervisorCamerasSearch(
  search: SupervisorOrganizationSearch,
): SupervisorCamerasSearch {
  return {
    organizationId: search.organizationId,
    dateFrom: search.dateFrom,
    dateTo: search.dateTo,
  };
}
